<template>
  <div class="navbar-container d-flex content align-items-center">
    <template v-if="$route.meta.showSearchSelectHeader">
      <SelectSearchList />
    </template>
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <!-- <dark-Toggler class="d-none d-lg-block" /> -->
      <template v-if="$route.meta.showSearchStatisticsHeader">
        <SearchHeader />
      </template>
      <template v-if="$route.meta.showSearchStatisticsHeaderV3">
        <SearchV3Header />
      </template>
    </div>

    <ChooseLanguage />
    <ProfileDropDown />
  </div>
</template>

<script>
import {
  BLink,
} from 'bootstrap-vue'
// import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import ProfileDropDown from '@/layouts/components/ProfileDropDown.vue'
import ChooseLanguage from '@/layouts/components/I18n.vue'
import SearchHeader from '@/views/components/search/SearchHeader.vue'
import SelectSearchList from '@/views/components/search/SelectSearchInstance.vue'
import SearchV3Header from '@/views/components/search/SearchV3Header.vue'

export default {
  components: {
    SearchV3Header,
    SelectSearchList,
    BLink,
    // Navbar Components
    ProfileDropDown,
    ChooseLanguage,
    SearchHeader,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
}
</script>
